import { Injectable } from '@angular/core';
import { AgentsService } from '../agents/agents.service';
import { AlertService } from '../alert/alert.service';
import { Agent } from '@app/shared/models/agent';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgentRatingService {

  constructor(
    private agentsService: AgentsService,
    private alertService: AlertService
  ) { }

  rateAgent(agentId: string, liked: boolean): Observable<Agent> {
    const ratingAction = liked
      ? this.agentsService.likeAgent(agentId)
      : this.agentsService.unlikeAgent(agentId);

    return ratingAction.pipe(
      tap({
        error: () => this.alertService.showError('An error occurred while rating the agent. Please try again later.')
      })
    );
  }
}
